export const POSSIBLE_DECIMAL_SEPARATORS = new Set(['.', ',']);

export const POSSIBLE_MINUS_KEYS = new Set(['-', '−']);

export const TRAILING_ZEROS_REGEX = /0+$/;
